module.exports = __webpack_public_path__ + "img/f34.624fa5eb.jpg";